export const environment = {
    BASE_URL: 'prod1.serveture.com',
    DISPLAY_WEB_URL: '.serveture.com',
    PENTAHO_URL: 'https://prod1pentaho.serveture.com:8443',
};